<button id="closebutton" aria-label="close filter options" type="button" (click)="closeDialog()">CLOSE <span class="material-symbols-outlined cancel-icon">
    cancel
</span> </button>
<img src="../../assets/images/lsa-proficiency-scale.png" width="100%" alt="Proficiency Scale">